// react-router-dom components
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { SIGN_IN_ROUTE } from "utils/routes";

function Logout() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [pass, setPass] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
        localStorage.removeItem("tradez-token");
        navigate(SIGN_IN_ROUTE);
    }, []);

    return (
       <></>
    );
}

export default Logout;
